import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'th',
  months: [
    'มกราคม',
    'กุมภาพันธ์',
    'มีนาคม',
    'เมษายน',
    'พฤษภาคม',
    'มิถุนายน',
    'กรกฎาคม',
    'สิงหาคม',
    'กันยายน',
    'ตุลาคม',
    'พฤศจิกายน',
    'ธันวาคม',
  ],
  monthsShort: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
  weekdays: ['วันอาทิตย์', 'วันจันทร์', 'วันอังคาร', 'วันพุธ', 'วันพฤหัสบดี', 'วันศุกร์', 'วันเสาร์'],
  weekdaysMin: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
  weekdaysShort: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd D MMM YYYY h:mm A',
    'llll-Y': 'ddd D MMM h:mm A',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm น. ([GMT]Z)',
    'LLL+to': 'D MMMM  YYYY HH:mm น. ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { other: '%s ปีที่แล้ว' },
    M: { other: '%s เดือนที่แล้ว' },
    w: { other: '%s สัปดาห์ที่แล้ว' },
    d: { other: '%s วันที่แล้ว' },
    h: { other: '%s ชม. ที่แล้ว' },
    m: { other: '%s นาทีที่แล้ว' },
    s: { other: '%s วินาทีที่แล้ว' },
  },
  future: {
    y: { other: 'ใน %s ปี' },
    M: { other: 'ใน %s เดือน' },
    w: { other: 'ใน %s สัปดาห์' },
    d: { other: 'ใน %s วัน' },
    h: { other: 'ใน %s ชม.' },
    m: { other: 'ใน %s นาที' },
    s: { other: 'ใน %s วินาที' },
  },
  abbr: {
    y: { other: '%s ปี' },
    M: { other: '%sเดือน' },
    w: { other: '%s สัปดาห์' },
    d: { other: '%sวัน' },
    h: { other: '%sชม.' },
    m: { other: '%sนาที' },
    s: { other: '%sวินาที' },
  },
  justNow: 'เมื่อสักครู่',
  yesterday: 'เมื่อวานนี้',
  today: 'วันนี้',
  tomorrow: 'พรุ่งนี้',
  weekStart: 0,
};
const localeName: LocaleName = 'th';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
